{
  "version": 1,
  "asset_id": "53986b9c-f477-41e0-9c81-9f766fe3cb60",
  "project_id": "1d7b8e6b-eeef-4a52-9dda-b5fbba0dd955",
  "url": "/__l5e/assets-v1/53986b9c-f477-41e0-9c81-9f766fe3cb60/sse-logo-white-360.webp",
  "r2_key": "a/v1/1d7b8e6b-eeef-4a52-9dda-b5fbba0dd955/53986b9c-f477-41e0-9c81-9f766fe3cb60/sse-logo-white-360.webp",
  "original_filename": "sse-logo-white-360.webp",
  "size": 8666,
  "content_type": "image/webp",
  "created_at": "2026-07-08T17:11:47Z"
}
